<template>
  <div 
    v-if="show" 
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm"
    @click="closeModal"
  >
    <div class="relative max-w-4xl max-h-[90vh] mx-4">
      <!-- Close button -->
      <button
        @click="closeModal"
        class="absolute top-4 right-4 z-10 p-2 bg-black bg-opacity-50 text-white rounded-full hover:bg-opacity-70 transition-all"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      
      <!-- Image -->
      <img
        :src="displayImage"
        :alt="imageAlt"
        class="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
        @click.stop
      />
      
      <!-- Image info -->
      <div 
        v-if="imageAlt" 
        class="absolute bottom-4 left-4 right-4 bg-black bg-opacity-50 text-white p-3 rounded-lg backdrop-blur-sm"
      >
        <p class="text-sm font-medium">{{ imageAlt }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch, computed } from 'vue'

interface Props {
  show: boolean
  imageUrl: string
  imageAlt?: string
}

interface Emits {
  close: []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

// Use default image if imageUrl is empty, null, or undefined
const displayImage = computed(() => {
  return props.imageUrl && props.imageUrl.trim() ? props.imageUrl : '/images/empty_image.png'
})

const closeModal = () => {
  emit('close')
}

// Close modal on escape key
watch(() => props.show, (isOpen) => {
  if (isOpen) {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeModal()
      }
    }
    document.addEventListener('keydown', handleEscape)
    document.body.style.overflow = 'hidden'
    
    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'auto'
    }
  } else {
    document.body.style.overflow = 'auto'
  }
})
</script>